export default "__VITE_ASSET__vGMotHgN__"